import { Component } from '@angular/core';

@Component({
  standalone: false,
  templateUrl: './about.component.html'
})
export class AboutComponent {}
